import axios from 'axios';
import { getDomainAndSubdomain } from 'shared/utils/getDomainAndSubdomain';

export const axiosInstance = axios.create();

let getIdTokenClaimsFn = null;

export function setGetIdTokenClaims(fn) {
  getIdTokenClaimsFn = fn;
}

axiosInstance.interceptors.request.use(async config => {
  const baseURL = process.env.REACT_APP_BASE_API_URL;
  const myAreaBaseDomain = process.env.REACT_APP_MY_AREA_URL;
  const env = process.env.REACT_APP_ENV;

  let token = '';

  if (getIdTokenClaimsFn) {
    const claims = await getIdTokenClaimsFn();
    const roles =
      claims['https://duck.energy/roles']?.map(role => role.toLowerCase()) ||
      [];
    if (roles.includes('user')) {
      // A full portal URL (e.g. the deployed portal Static Web App / custom domain)
      // takes precedence over the subdomain-derived my.<sub>.<domain> host, which needs
      // DNS that may not exist (e.g. in the demo environment).
      const myUrl = process.env.REACT_APP_MY_URL;
      if (myUrl) {
        window.location.href = myUrl;
        return;
      }

      const { subdomain } = getDomainAndSubdomain();
      const redirectURL =
        env === 'production'
          ? `${subdomain}.${myAreaBaseDomain}`
          : `test.${subdomain}.${myAreaBaseDomain}`;
      window.location.href = `https://${redirectURL}`;
      return;
    }

    token = claims?.__raw || '';
  }

  return {
    ...config,
    baseURL,
    headers: {
      ...config.headers,
      Authorization: token ? `Bearer ${token}` : ''
    }
  };
});

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    // if (error.response && error.response.status === 401) {
    //   const originalRequest = error.config;
    //   if (originalRequest._retry) {
    //     removeCookies();
    //     window.location.href = '/welcome';
    //     return;
    //   }

    //   originalRequest._retry = true;

    //   const refreshToken = Cookies.get('refreshToken');
    //   if (!refreshToken) {
    //     removeCookies();
    //     window.location.href = '/welcome';
    //     return Promise.reject(error);
    //   }

    //   try {
    //     const token = Cookies.get('accessToken');
    //     if (token) {
    //       const decodedToken = jwtDecode(token);
    //       const groups = decodedToken['cognito:groups'];
    //       const tenantName = findGroup(groups, 'tenant:').toLowerCase();

    //       await refreshAccessToken(tenantName, refreshToken);

    //       const newAccessToken = Cookies.get('accessToken');
    //       if (!newAccessToken) {
    //         throw new Error('Failed to refresh access token');
    //       }

    //       originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
    //       return axiosInstance(originalRequest);
    //     }
    //   } catch (refreshError) {
    //     removeCookies();
    //     window.location.href = '/welcome';
    //     return Promise.reject(refreshError);
    //   }
    // }

    return Promise.reject(error);
  }
);

// async function refreshAccessToken(tenantName, refreshToken) {
//   const state = store.getState();
//   const { apiBaseUrl: baseURL, apiVersion } = state.config;

//   await axios.post(
//     `${baseURL}/iam/auth/token/refresh/${tenantName}`,
//     refreshToken,
//     {
//       headers: {
//         'Content-Type': 'text/plain',
//         'DUCKENERGY-API-VERSION': apiVersion ?? API_DUCKENERGY_VERSION
//       }
//     }
//   );
// }

export class ApiClient {
  constructor(url) {
    this.serviceUrl = url;
    this.requestService = axiosInstance;
  }

  async get(url, options = {}) {
    const isAxiosConfig =
      options?.responseType || options?.headers || options?.params;

    const res = await this.requestService.get(
      `${this.serviceUrl}${url}`,
      isAxiosConfig ? options : { params: options }
    );

    if (isAxiosConfig && options.responseType === 'blob') {
      return res;
    }

    return res.data;
  }

  async post(url, body, query) {
    const res = await this.requestService.post(
      `${this.serviceUrl}${url}`,
      body,
      { params: query }
    );

    return res.data;
  }

  async patch(url, body, query) {
    const res = await this.requestService.patch(
      `${this.serviceUrl}${url}`,
      body,
      { params: query }
    );
    return res.data;
  }

  async put(url, body, query) {
    const res = await this.requestService.put(
      `${this.serviceUrl}${url}`,
      body,
      { params: query }
    );
    return res.data;
  }

  async delete(url, query) {
    const res = await this.requestService.delete(`${this.serviceUrl}${url}`, {
      params: query
    });
    return res.data;
  }
}

export default ApiClient;
